import axios from 'axios';
import { ATOMIC_API_ENDPOINTS } from '../constants/wax.constants';

let currentEndpointIndex = 0;

// Keep the Axios response shape for callers using either AtomicAssets or AtomicMarket.
export const requestAtomicApi = async (path, config = {}) => {
  const startIndex = currentEndpointIndex;

  for (let attempt = 0; attempt < ATOMIC_API_ENDPOINTS.length; attempt += 1) {
    const endpointIndex = (startIndex + attempt) % ATOMIC_API_ENDPOINTS.length;

    try {
      // Fail over sequentially without duplicating successful requests.
      // eslint-disable-next-line no-await-in-loop
      const response = await axios.get(`${ATOMIC_API_ENDPOINTS[endpointIndex]}/${path}`, {
        ...config,
        timeout: 10000,
      });
      currentEndpointIndex = endpointIndex;
      return response;
    } catch (error) {
      const status = error.response && Number(error.response.status);
      const retryable = !error.response || status === 429 || status >= 500;

      if (!retryable) throw error;
      if (attempt === ATOMIC_API_ENDPOINTS.length - 1) {
        throw new Error('NetworkError! All Atomic API endpoints are unavailable.');
      }
    }
  }
};

export const getDataFromAtomicApi = async (path) => {
  const { data: { data } } = await requestAtomicApi(`atomicassets/v1/${path}`);
  return data;
};
